<template>
  <HeadlessTransitionRoot
    appear
    as="template"
    :show="isOpen"
  >
    <HeadlessDialog
      as="div"
      class="relative"
      @close="onClose"
    >
      <HeadlessTransitionChild
        as="template"
        enter="duration-500 ease-out"
        enter-from="opacity-0 scale-95"
        enter-to="opacity-100 scale-100"
        leave="duration-100 ease-in"
        leave-from="opacity-100 scale-100"
        leave-to="opacity-0 scale-95"
      >
        <div class="fixed inset-0 bg-black/25" />
      </HeadlessTransitionChild>

      <div
        class="fixed inset-0 flex h-full items-center justify-center p-4"
      >
        <HeadlessTransitionChild
          as="template"
          enter="duration-100 ease-out"
          enter-from="opacity-0 scale-95"
          enter-to="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leave-from="opacity-100 scale-100"
          leave-to="opacity-0 scale-95"
        >
          <HeadlessDialogPanel
            class="relative max-h-full overflow-y-auto rounded-lg bg-background px-4 shadow-xl transition-all"
            :class="
              {
                sm: 'max-w-md',
                lg: 'max-w-full',
              }[size]
            "
          >
            <slot />
            <BaseInnerLoading v-if="isLoading" />
          </HeadlessDialogPanel>
        </HeadlessTransitionChild>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    isOpen: boolean
    isLoading?: boolean
    size?: "sm" | "lg"
  }>(),
  {
    isLoading: false,
    size: "sm",
  }
)

const emit = defineEmits<{ (event: "close"): void }>()

const onClose = () => emit("close")
</script>
